/**
 * @author Hiroki Moto
 * @description Used for display Department forums
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CommunityActions from '~/actions/community';
import VendorActions from '~/actions/vendor';
import { PulseLoader } from 'react-spinners';

const DepartmentForum = ({ title, departments, loading }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const subStatus = useSelector((state) => state.community.subStatus);
    useEffect(() => {
        dispatch(VendorActions.getallcategorypopularproductsRequest({}, loading));
        dispatch(CommunityActions.gettopicsRequest({}, loading));
    }, []);

    return (
        <div className="card department-forum-card">
            <div className="dsl-b18 bold department-title cursor-pointer pt-0">
                <a href="https://www.drivingsales.com/forums" className="dsl-b18 text-600">
                    {title}
                </a>
            </div>
            {subStatus.includes('pending-forum') ? (
                <div className="space">
                    <PulseLoader className={18} loading color={'#376caf'} size={18} />
                </div>
            ) : (
                <>
                    <div className="list-item mt-2 pb-2">
                        <div className="d-flex-6" />
                        <div className="d-flex-1 text-end">
                            <span className="dsl-m12 text-400">Topics</span>
                        </div>
                        <div className="d-flex-3 text-end">
                            <span className="dsl-m12 text-400">Comments</span>
                        </div>
                        <div className="d-flex-2 text-end">
                            <span className="dsl-m12 text-400">Views</span>
                        </div>
                    </div>
                    {departments?.length > 0 ? (
                        departments.map((item, index) => (
                            <div className="dept-hover cursor-pointer" key={index}>
                                <div className="list-item mt-2 pb-2">
                                    <div className="d-flex-5" onClick={() => navigate(`/community/forum-department-feed/${item.id}`)}>
                                        <span className="dsl-b14">{item.name}</span>
                                    </div>
                                    <div className="d-flex-3 text-end">
                                        <span className="dsl-b14">{item.data.stats.forum_discussions_abbr}</span>
                                    </div>
                                    <div className="d-flex-3 text-end">
                                        <span className="dsl-b14">{item.data.stats.forum__comments_abbr}</span>
                                    </div>
                                    <div className="d-flex-3 text-end">
                                        <span className="dsl-b14">{item.data.stats.forum__views_abbr}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="dsl-m14 text-center">No department available</div>
                    )}
                </>
            )}
        </div>
    );
};

DepartmentForum.propTypes = {
    title: PropTypes.string,
    departments: PropTypes.array,
};

DepartmentForum.defaultProps = {
    title: '',
    departments: [],
};

export default DepartmentForum;
